import hasRole from './hasRole'
import hasPermi from './hasPermi'
import hasAuth from './hasAuth'
const install = function(Vue) {
  Vue.directive('hasRole', hasRole)
  Vue.directive('hasPermi', hasPermi)
  Vue.directive('hasAuth', hasAuth)
}

if (window.Vue) {
  window['hasRole'] = hasRole
  window['hasPermi'] = hasPermi
  window['hasAuth'] = hasAuth
  Vue.use(install); // eslint-disable-line
}

export default install
